import { Grid, Tooltip, Typography } from '@material-ui/core'
import { formatLocalDate } from './date-time'
import { Person, Procedure, Provider, emElementsLabel } from './domain'

export function withTooltip(tooltip: string, element: any, placement = 'right-end'): JSX.Element {
  return tooltip ? (
    <Tooltip
      title={<span style={{ whiteSpace: 'pre-line', fontSize: 12 }}>{tooltip}</span>}
      placement={placement as any}
    >
      <span>{element}</span>
    </Tooltip>
  ) : (
    element
  )
}

export function truncate(width: string, fixed = true): any {
  return {
    width: fixed ? width : undefined,
    maxWidth: width,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
  }
}

export function truncateSpan(value: string, width: string, fixed = true, id = null) {
  return withTooltip(
    value,
    <div id={id} style={truncate(width, fixed)}>
      {value}
    </div>,
    'bottom',
  )
}

export function personName(v: Person | Provider): string {
  if (!v?.lastName) {
    return ''
  }
  return `${v.lastName}, ${v.firstName}`
}

export function personNameWithDegree(v: Person | Provider): string {
  if (!v?.lastName) {
    return ''
  }
  if (v?.degree) {
    return `${v.lastName}, ${v.firstName} ${v.degree}`
  }
  return `${v.lastName}, ${v.firstName}`
}

export const splitCamelCase = (name: string) =>
  name ? name.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (s) => s.toUpperCase()) : ''

export type Stringify<T = any> = {
  [key in keyof T]: (value: any) => string
}
export type StringifyFn<T = any> = (obj: any, fieldName: keyof T) => string

export function stringify<T = any>(obj: T, valueLabels: Stringify<T>): StringifyFn {
  const defaultLabel = (value: any) => (value ? value + '' : '')
  return (obj, field) => (valueLabels[field] || defaultLabel)(obj[field])
}

export function stringifyProcedure(opt?: Stringify<Procedure>): Stringify<Procedure> {
  return {
    ...{
      serviceDate: (v) => formatLocalDate(v),
      serviceLocation: (v) => v?.description || '',
      provider: (v) => personName(v),
      secondaryProvider: (v) => personName(v),
      tertiaryProvider: (v) => personName(v),
      modifiers: (v) => (typeof v === 'string' ? v : (v || []).join(',')),
      links: (v) => v,
      emCalculator: emElementsLabel,
    },
    ...opt,
  }
}

export function LabelItem(label: string, style?: any, xs: any = 3) {
  return (
    <Grid
      item
      xs={!isNaN(xs) ? xs : undefined}
      style={{
        ...{
          maxWidth: 200,
          overflowX: 'hidden',
        },
        ...style,
      }}
    >
      {withTooltip(
        label,
        <Typography
          variant="body2"
          style={{
            width: '100%',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflowX: 'hidden',
            paddingLeft: 6,
            fontSize: style.fontSize || 14,
          }}
        >
          {label}
        </Typography>,
        'bottom',
      )}
    </Grid>
  )
}
